<template>
    <div class="col-md-12">
        <div class="card">
            <div class="card-header pb-0">                
                <button class="btn btn-danger float-end" @click="store.resetForm">
                    <vue-feather type="refresh-cw" size="16"></vue-feather>
                </button>
                <h4><b>Nuevo asegurado</b></h4>                
                <span><b>Instrucciones:</b> 
                    <br />1. Complete todos los campos requeridos.
                    <br />2. Navegue a través de las secciones del formulario.
                    <br />3. Revise la información antes de enviarla a la aseguradora.
                </span>
                <br />
            </div>
            <div class="card-body">
                <Wizard 
                    :custom-tabs="[
                        {
                            title: 'Personales',
                        },
                        {
                            title: 'Laborales',
                        },
                    ]" 
                    :beforeChange="onTabBeforeChange" 
                    @change="onChangeCurrentTab" 
                    @complete:wizard="wizardCompleted"                    
                >
                <!-- Le quité la acción de submit arriba en el wizard -->
                
                <!-- Tabs -->
                <div class="col-xs-12" v-if="currentTabIndex === 0">
                    <personales />
                </div>                    
                <div class="col-xs-12 text-start" v-if="currentTabIndex === 1">
                   <laborales />
                </div>                
                <!-- End Tabs -->
                </Wizard>
            </div>
        </div>
    </div>
</template>

<script>
import "form-wizard-vue3/dist/form-wizard-vue3.css";
import Wizard from "form-wizard-vue3";
import personales from "./formularioPersonales.vue";
import laborales from "./formularioLaborales.vue";
import { useSeguroStore } from '@/stores/seguroStore';

export default {
    setup() {
        const store = useSeguroStore();
        return { store };
    },
    name: "App",
    components: {
        Wizard,
        personales,
        laborales,
    },
    data() {
        return {
            currentTabIndex: 0,
        };
    },
    methods: {
        onChangeCurrentTab(index, oldIndex) {
            this.currentTabIndex = index;
        },
        onTabBeforeChange() {
            if (this.currentTabIndex === 0) {
                // Punto de extensión: validar antes de cambiar de pestaña.
            }
        },
        wizardCompleted() {
        },
    },
};
</script>